// src/router.js

import { createRouter, createWebHistory } from 'vue-router';

import workboard from './views/workboard.vue';
import shopSettings from './views/shopSettings.vue';
import products from './views/products.vue';
import singleProduct from './views/singleProduct.vue';
import orders from './views/orders.vue';
import singleOrder from './views/singleOrder.vue';
import userLogin from './views/login.vue';

import errorPage from './views/errorPage.vue';
// import isAuth from './components/isAuth'

const routes = [
    { 
        path: '/', 
        component: workboard, 
        name: 'workboard', 
        meta: { requiresAuth: true, authGroups: ['admin','seller'] },
        props: true
    },
    { 
        path: '/login', 
        component: userLogin, 
        name: 'userLogin', 
        meta: { requiresAuth: false, authGroups: ['guest'] },
        props: true
    },
    { 
        path: '/toolaud/pood', 
        component: shopSettings, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'shopSettings', 
        props: true
    },
    { 
        path: '/toolaud/tooted', 
        component: products, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'products', 
        props: true
    },
    { 
        path: '/toode/:idListing', 
        component: singleProduct, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'singleProduct', 
        props: true
    },
    { 
        path: '/toolaud/tellimused', 
        component: orders, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'orders', 
        props: true
    },
    { 
        path: '/tellimus/:idOrder/:idDeal', 
        component: singleOrder, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin', 'base'] },
        name: 'singleOrder', 
        props: true
    },
    { 
        path: '/veateade', 
        component: errorPage, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin', 'base'] },
        name: '403Page', 
        props: true
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    let isAuthenticated = false;
    let userGroups = [];
  
    try {
        const response = await fetch(process.env.VUE_APP_MAIN_URL + '/v2/roundtrip', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        const res = await response.json();
        isAuthenticated = !!res.isAuthenticated;
        userGroups = res.userGroups || [];
    } catch (error) {
        console.error('Error fetching authentication status:', error);
        // On error, default to unauthenticated to avoid infinite loops
        // isAuthenticated remains false
    }
  
    // OPTIONAL: Attach the auth status to the route (in case you need it later)
    to.meta.isAuthenticated = isAuthenticated;
  
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth === true);
    const routeAuthGroups = to.meta.authGroups || [];
  
    if (requiresAuth) {
        // 1. Route requires authentication
        if (!isAuthenticated) {
            return next('/login');
        }
        // 2. If authenticated, check group-based authorization
        const hasAccess =
            routeAuthGroups.length === 0 ||
            userGroups.some(group => routeAuthGroups.includes(group));
    
        if (!hasAccess) {
            return next('/veateade'); // or wherever you'd like to show "no access"
        }
        // 3. All good: let them in
        return next();
  
    } else {
        // Route does NOT require authentication
        // => If user IS authenticated and tries to go to /login (or any public route),
        //    redirect them to '/'
        if (isAuthenticated) {
            return next('/');
        }
        // Otherwise, no auth needed—let them proceed
        return next();
    }
});

export default router;
